import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Improved scroll to top with better performance
    const scrollToTop = () => {
      try {
        // Use requestAnimationFrame for better performance
        requestAnimationFrame(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
          });
          
          // Fallback for older browsers
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        });
      } catch (error) {
        // Silent fallback
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      }
    };

    // Override browser's scroll restoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    // Execute scroll immediately
    scrollToTop();
  }, [pathname]);

  return null;
};

export default ScrollToTop;